"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.audio75 = void 0;
var util_1 = require("./util");
var audio75 = function (event) {
    return (0, util_1.audioEvent)(event, "audio-75");
};
exports.audio75 = audio75;
